import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=5e01d8c6&scoped=true&lang=pug&"
import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageHeader.scss?vue&type=style&index=0&id=5e01d8c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01d8c6",
  null
  
)

export default component.exports